import React from "react";

export const LinkedinIcon = () => {
  return (
    <svg width="72" height="71" viewBox="0 0 72 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="35.9436" cy="35.3889" r="35.3889" fill="#007AB7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.9192 30.2148H23.6496V47.1858H28.9192V30.2148ZM29.3521 24.839C29.3521 23.1517 27.9809 21.7783 26.2962 21.7783C24.6017 21.7783 23.2402 23.1517 23.2402 24.839C23.2402 26.5263 24.6017 27.8996 26.2962 27.8996C27.9809 27.8996 29.3521 26.5263 29.3521 24.839ZM37.2748 30.2143H32.2403V47.1853H37.5001V38.7881C37.5001 36.5809 37.9114 34.4326 40.6539 34.4326C43.3573 34.4326 43.3867 36.9635 43.3867 38.9353V47.1853H48.6464V37.8856C48.6464 33.3142 47.6571 29.8023 42.3288 29.8023C39.7626 29.8023 38.0486 31.2051 37.3433 32.5393H37.2748V30.2143Z"
        fill="white"
      />
    </svg>
  );
};
